import { useCallback } from "react";
import { AttemptRequestBody, ITake } from "@imaginelearning/mps-api-service";
import AppWindow from "../../helpers/app-window";
import useProductOriginDomain from "./useProductOriginDomain";

export interface IAttemptOptionOverrides {
  tags?: string;
  introMode?: string;
  outroMode?: string;
  paginationMode?: string;
  language?: string;
}

export default function useAssessmentAttemptOptions(state: string, assignmentId: string) {
  const { domain } = useProductOriginDomain();

  const buildAttemptRequestBody = useCallback(
    (take: ITake, overrides: IAttemptOptionOverrides = {}): AttemptRequestBody => {
      const appWindow = AppWindow();
      const attemptOptions: AttemptRequestBody = {
        attemptId: take.takeID,
        pathId: `${take.pathID}`,
        pathVersion: `${take.version}`,
        metadata: {
          stateForStandards: state,
          assignmentId,
          tags: overrides?.tags ?? `ABLD|Formatives|${assignmentId}`
        },
        introMode: overrides.introMode ?? "Standard",
        outroMode: overrides.outroMode ?? "Standard",
        paginationMode: overrides?.paginationMode ?? "Standard",
        language: overrides?.language ?? "en",
        ctkEnvUrl: appWindow.STUDENT_ENV.REACT_APP_FIXEDFORM_PLAYER_CTK_ENV_URL,
        ctkEnvId: appWindow.STUDENT_ENV.REACT_APP_FIXEDFORM_PLAYER_CTK_ENV_ID,
        productOriginDomain: domain
      };
      return attemptOptions;
    },
    [assignmentId, domain, state]
  );

  return { buildAssessmentAttemptOptions: buildAttemptRequestBody };
}
